import _ from 'lodash';
import {
  INIT_MAIN,
  TOGGLE_OPTION_SUCCESS,
  TOGGLE_OPTION_CONFLICT_RESOLVE,
  UPDATE_CONFIG_SUCCESS,
  START_OVER_SUCCESS,
} from '../actionTypes';

export default function rpos(state, action) {
  switch (action.type) {
    case INIT_MAIN:
    case TOGGLE_OPTION_SUCCESS:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
    case UPDATE_CONFIG_SUCCESS:
    case START_OVER_SUCCESS:
      return _.get(action.payload.fullConfig, 'config.selected');
    default:
      return state || [];
  }
}
